import { inject as we, computed as o, ref as f, watch as F } from "vue";
import { dateArray as Ve, monthArray as Ce, yearArray as je, quarterArray as Se, strictParse as M, getDefaultTime as ge } from "./ghl-ui.es987.js";
import { datePickerInjectionKey as Fe } from "./ghl-ui.es989.js";
import { usePanelCommonProps as Me, usePanelCommon as qe } from "./ghl-ui.es1546.js";
import { MONTH_ITEM_HEIGHT as q, START_YEAR as Pe } from "./ghl-ui.es1335.js";
import v from "./ghl-ui.es999.js";
import Ue from "./ghl-ui.es1347.js";
import P from "./ghl-ui.es1000.js";
import r from "./ghl-ui.es1001.js";
import k from "./ghl-ui.es1149.js";
import D from "./ghl-ui.es1346.js";
import b from "./ghl-ui.es1337.js";
import U from "./ghl-ui.es1345.js";
import Ye from "./ghl-ui.es1535.js";
import Y from "./ghl-ui.es1536.js";
import _e from "./ghl-ui.es1534.js";
import _ from "./ghl-ui.es1344.js";
import x from "./ghl-ui.es1342.js";
import xe from "./ghl-ui.es1148.js";
import Ee from "./ghl-ui.es1338.js";
import He from "./ghl-ui.es1341.js";
import We from "./ghl-ui.es1528.js";
import Ne from "./ghl-ui.es1529.js";
import ze from "./ghl-ui.es1527.js";
const va = Object.assign(Object.assign({}, Me), {
  defaultCalendarStartTime: Number,
  actions: {
    type: Array,
    default: () => ["now", "clear", "confirm"]
  }
});
function ma(a, i) {
  var R;
  const n = qe(a), {
    isValueInvalidRef: E,
    isDateDisabledRef: H,
    isDateInvalidRef: W,
    isTimeInvalidRef: N,
    isDateTimeInvalidRef: z,
    isHourDisabledRef: L,
    isMinuteDisabledRef: Q,
    isSecondDisabledRef: B,
    localeRef: s,
    firstDayOfWeekRef: w,
    datePickerSlots: G,
    yearFormatRef: I,
    monthFormatRef: K,
    quarterFormatRef: J
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } = we(Fe), O = {
    isValueInvalid: E,
    isDateDisabled: H,
    isDateInvalid: W,
    isTimeInvalid: N,
    isDateTimeInvalid: z,
    isHourDisabled: L,
    isMinuteDisabled: Q,
    isSecondDisabled: B
  }, m = o(() => a.dateFormat || s.value.dateFormat), d = f(a.value === null || Array.isArray(a.value) ? "" : v(a.value, m.value)), u = f(a.value === null || Array.isArray(a.value) ? (R = a.defaultCalendarStartTime) !== null && R !== void 0 ? R : Date.now() : a.value), y = f(null), V = f(null), T = f(null), A = f(Date.now()), C = o(() => {
    var e;
    return Ve(u.value, a.value, A.value, (e = w.value) !== null && e !== void 0 ? e : s.value.firstDayOfWeek, !1, i === "week");
  }), X = o(() => {
    const {
      value: e
    } = a;
    return Ce(u.value, Array.isArray(e) ? null : e, A.value, {
      monthFormat: K.value
    });
  }), Z = o(() => {
    const {
      value: e
    } = a;
    return je(Array.isArray(e) ? null : e, A.value, {
      yearFormat: I.value
    });
  }), $ = o(() => {
    const {
      value: e
    } = a;
    return Se(u.value, Array.isArray(e) ? null : e, A.value, {
      quarterFormat: J.value
    });
  }), p = o(() => C.value.slice(0, 7).map((e) => {
    const {
      ts: t
    } = e;
    return v(t, s.value.dayFormat, n.dateFnsOptions.value);
  })), ee = o(() => v(u.value, s.value.monthFormat, n.dateFnsOptions.value)), ae = o(() => v(u.value, s.value.yearFormat, n.dateFnsOptions.value));
  F(u, (e, t) => {
    (i === "date" || i === "datetime") && (Ue(e, t) || n.disableTransitionOneTick());
  }), F(o(() => a.value), (e) => {
    e !== null && !Array.isArray(e) ? (d.value = v(e, m.value, n.dateFnsOptions.value), u.value = e) : d.value = "";
  });
  function c(e) {
    var t;
    if (i === "datetime")
      return r(xe(e));
    if (i === "month")
      return r(Ee(e));
    if (i === "year")
      return r(He(e));
    if (i === "quarter")
      return r(We(e));
    if (i === "week") {
      const l = (((t = w.value) !== null && t !== void 0 ? t : s.value.firstDayOfWeek) + 1) % 7;
      return r(Ne(e, {
        weekStartsOn: l
      }));
    }
    return r(ze(e));
  }
  function j(e, t) {
    const {
      isDateDisabled: {
        value: l
      }
    } = O;
    return l ? l(e, t) : !1;
  }
  function te(e) {
    const t = M(e, m.value, /* @__PURE__ */ new Date(), n.dateFnsOptions.value);
    if (P(t)) {
      if (a.value === null)
        n.doUpdateValue(r(c(Date.now())), a.panel);
      else if (!Array.isArray(a.value)) {
        const l = k(a.value, {
          year: D(t),
          month: b(t),
          date: U(t)
        });
        n.doUpdateValue(r(c(r(l))), a.panel);
      }
    } else
      d.value = e;
  }
  function ne() {
    const e = M(d.value, m.value, /* @__PURE__ */ new Date(), n.dateFnsOptions.value);
    if (P(e)) {
      if (a.value === null)
        n.doUpdateValue(r(c(Date.now())), !1);
      else if (!Array.isArray(a.value)) {
        const t = k(a.value, {
          year: D(e),
          month: b(e),
          date: U(e)
        });
        n.doUpdateValue(r(c(r(t))), !1);
      }
    } else
      fe();
  }
  function re() {
    n.doUpdateValue(null, !0), d.value = "", n.doClose(!0), n.handleClearClick();
  }
  function le() {
    n.doUpdateValue(r(c(Date.now())), !0);
    const e = Date.now();
    u.value = e, n.doClose(!0), a.panel && (i === "month" || i === "quarter" || i === "year") && (n.disableTransitionOneTick(), h(e));
  }
  const S = f(null);
  function ie(e) {
    e.type === "date" && i === "week" && (S.value = c(r(e.ts)));
  }
  function ue(e) {
    return e.type === "date" && i === "week" ? c(r(e.ts)) === S.value : !1;
  }
  function oe(e) {
    if (j(e.ts, e.type === "date" ? {
      type: "date",
      year: e.dateObject.year,
      month: e.dateObject.month,
      date: e.dateObject.date
    } : e.type === "month" ? {
      type: "month",
      year: e.dateObject.year,
      month: e.dateObject.month
    } : e.type === "year" ? {
      type: "year",
      year: e.dateObject.year
    } : {
      type: "quarter",
      year: e.dateObject.year,
      quarter: e.dateObject.quarter
    }))
      return;
    let t;
    if (a.value !== null && !Array.isArray(a.value) ? t = a.value : t = Date.now(), i === "datetime" && a.defaultTime !== null && !Array.isArray(a.defaultTime)) {
      const l = ge(a.defaultTime);
      l && (t = r(k(t, l)));
    }
    switch (t = r(e.type === "quarter" && e.dateObject.quarter ? Ye(Y(t, e.dateObject.year), e.dateObject.quarter) : k(t, e.dateObject)), n.doUpdateValue(c(t), a.panel || i === "date" || i === "week" || i === "year"), i) {
      case "date":
      case "week":
        n.doClose();
        break;
      case "year":
        a.panel && n.disableTransitionOneTick(), n.doClose();
        break;
      case "month":
        n.disableTransitionOneTick(), h(t);
        break;
      case "quarter":
        n.disableTransitionOneTick(), h(t);
        break;
    }
  }
  function de(e, t) {
    let l;
    a.value !== null && !Array.isArray(a.value) ? l = a.value : l = Date.now(), l = r(e.type === "month" ? _e(l, e.dateObject.month) : Y(l, e.dateObject.year)), t(l), h(l);
  }
  function ce(e) {
    u.value = e;
  }
  function fe(e) {
    if (a.value === null || Array.isArray(a.value)) {
      d.value = "";
      return;
    }
    e === void 0 && (e = a.value), d.value = v(e, m.value, n.dateFnsOptions.value);
  }
  function g() {
    O.isDateInvalid.value || O.isTimeInvalid.value || (n.doConfirm(), se());
  }
  function se() {
    a.active && n.doClose();
  }
  function ve() {
    var e;
    u.value = r(_(u.value, 1)), (e = a.onNextYear) === null || e === void 0 || e.call(a);
  }
  function me() {
    var e;
    u.value = r(_(u.value, -1)), (e = a.onPrevYear) === null || e === void 0 || e.call(a);
  }
  function ye() {
    var e;
    u.value = r(x(u.value, 1)), (e = a.onNextMonth) === null || e === void 0 || e.call(a);
  }
  function he() {
    var e;
    u.value = r(x(u.value, -1)), (e = a.onPrevMonth) === null || e === void 0 || e.call(a);
  }
  function De() {
    const {
      value: e
    } = y;
    return (e == null ? void 0 : e.listElRef) || null;
  }
  function be() {
    const {
      value: e
    } = y;
    return (e == null ? void 0 : e.itemsElRef) || null;
  }
  function Oe(e) {
    var t;
    (t = V.value) === null || t === void 0 || t.sync();
  }
  function Ae(e) {
    e !== null && n.doUpdateValue(e, a.panel);
  }
  function ke(e) {
    n.cachePendingValue();
    const t = n.getShortcutValue(e);
    typeof t == "number" && n.doUpdateValue(t, !1);
  }
  function Re(e) {
    const t = n.getShortcutValue(e);
    typeof t == "number" && (n.doUpdateValue(t, a.panel), n.clearPendingValue(), g());
  }
  function h(e) {
    const {
      value: t
    } = a;
    if (T.value) {
      const l = e === void 0 ? t === null ? b(Date.now()) : b(t) : b(e);
      T.value.scrollTo({
        top: l * q
      });
    }
    if (y.value) {
      const l = (e === void 0 ? t === null ? D(Date.now()) : D(t) : D(e)) - Pe;
      y.value.scrollTo({
        top: l * q
      });
    }
  }
  const Te = {
    monthScrollbarRef: T,
    yearScrollbarRef: V,
    yearVlRef: y
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    dateArray: C,
    monthArray: X,
    yearArray: Z,
    quarterArray: $,
    calendarYear: ae,
    calendarMonth: ee,
    weekdays: p,
    mergedIsDateDisabled: j,
    nextYear: ve,
    prevYear: me,
    nextMonth: ye,
    prevMonth: he,
    handleNowClick: le,
    handleConfirmClick: g,
    handleSingleShortcutMouseenter: ke,
    handleSingleShortcutClick: Re
  }, O), n), Te), {
    // datetime only
    handleDateClick: oe,
    handleDateInputBlur: ne,
    handleDateInput: te,
    handleDateMouseEnter: ie,
    isWeekHovered: ue,
    handleTimePickerChange: Ae,
    clearSelectedDateTime: re,
    virtualListContainer: De,
    virtualListContent: be,
    handleVirtualListScroll: Oe,
    timePickerSize: n.timePickerSize,
    dateInputValue: d,
    datePickerSlots: G,
    handleQuickMonthClick: de,
    justifyColumnsScrollState: h,
    calendarValue: u,
    onUpdateCalendarValue: ce
  });
}
export {
  ma as useCalendar,
  va as useCalendarProps
};
